import type { Iendpoint, IApp, Icontent} from '@/core/interfaceCoreInitial'

const _urlbase = import.meta.env.VITE_API_URL;
const baseImage = _urlbase.slice(0, -4)

class SettingsApplications {
    endPointMain: { [key: string]: Iendpoint };
    apps        : { [key: string]: IApp };
    modules     : { [key: string]: Icontent };
    actions     : { [key: string]: Icontent };

    constructor() {
      this.endPointMain = {
            urlBase: { name: baseImage                                },          
    checkPermission: { name: _urlbase+'/users/check-permission'       },          
             secure: { name: _urlbase+'/secure'                       },
             logins: { name: _urlbase+'/user-logins'                  },
          auditLogs: { name: _urlbase+'/user-logs'                    },
               core: { name: _urlbase                                 },
serviceRequestTypes: { name: _urlbase + '/service-request-types'      },
     serviceRequest: { name: _urlbase + '/service-requests'           },
   serviceSchedules: { name: _urlbase + '/service-schedules'          },
             cliets: { name: _urlbase+'/clients'                      },
           branches: { name: _urlbase + '/branches'                   },
          locations: { name: _urlbase + '/locations'                  },
              areas: { name: _urlbase + '/areas'                      },
           devices : { name: _urlbase+'/devices'                      },
             calls : { name: _urlbase+'/calls'                        },  
          dashBoard: { name: _urlbase+'/dashboard'                    },
        };
       
        this.apps = {   
            clients: { id: '517392161752311950', name: 'General', auth: false, url: '/', icon: 'icon-dashboard.png', nameComponet: 'dashBoard', title: "Welcome Consumer Portal", message: "Welcome to Consumer Portal", user: "customer@goconnexus.com", password: "5upp0rt@2023", consumerKey: "Z9ABIZNS7UWCYHVMW8VDFUIO9ICC40U2IKK6AOGD6QGQACU5J8", consumerSecret:"H0D5O8IY2YP93K3L2Y5BDVN6MGDT8HEN1WC60B7XQ8X7E0GLOF"},
        };

      this.modules = {
              logins: { idAplication: '517392161752311950', id: '517392161752311959', name: 'Login Sessions', nameComponet: '' },
           dashBoard: { idAplication: '517392161752311950', id: '517392161752311968', name: 'Dashboard',      nameComponet: '' },   
             clients: { idAplication: '517392161752311950', id: '517392161752311969', name: 'General',  nameComponet: '' },
               calls: { idAplication: '517392161752311950', id: '517392161752311985', name: 'Calls',    nameComponet: '' },
            branches: { idAplication: '517392161752311950', id: '517392161752311970', name: 'Branches', nameComponet: '' },
           locations: { idAplication: '517392161752311950', id: '517392161752311972', name: 'Locations',nameComponet: '' },
               areas: { idAplication: '517392161752311950', id: '517392161752311974', name: 'Areas',    nameComponet: ''    },
             devices: { idAplication: '517392161752311950', id: '517392161752311978', name: 'Devices',  nameComponet: '' },
 serviceRequestTypes: { idAplication: '517392161752311950', id: '517392161752311980', name: 'Services Request Types', nameComponet: '' },
      serviceRequest: { idAplication: '517392161752311950', id: '517392161752311981', name: 'Services Request', nameComponet: '' },
    serviceSchedules: { idAplication: '517392161752311950', id: '517392161752311982', name: 'Services Schedules', nameComponet: 'OperationsServicesSchedules' }, 
            //calls : { idAplication: '517392161752311950', id: '517392161752311985', name: 'Calls',    nameComponet: ''  },
               
        };
        
        this.actions = {
             access: { id: '517392161752311968', name: "Access"    , message: "Record Access"                  },
             create: { id: '517392161752311969', name: "Create"    , message: "Record Inserted Successfully"   }, 
             update: { id: '517392161752311970', name: "Update"    , message: "Record Updated Successfully"    }, 
             delete: { id: '517392161752311971', name: "Delete"    , message: "Record Deleted Successfully"    }, 
           activate: { id: '517392161752311972', name: "Activate"  , message: "Record Activate Successfully"   }, 
         deactivate: { id: '517392161752311973', name: "Deactivate", message: "Record Deactivate Successfully" }, 
             manage: { id: '517392161752311974', name: "Manage"    , message: "Record Access Manage" }, 
                add: { id: '517392161752311975', name: "Add"       , message: "Manage Assign Permissions" }, 
             remove: { id: '517392161752311976', name: "Remove"    , message: "Manage Remove Permissions" }, 
             search: { id: '517392161752311977', name: "Search"    , message: "Search parameters" }, 
               sync: { id: '517392161752311978', name: "Sync"      , message:"" }, 
              print: { id: '517392161752311979', name: "Print"     , message:"" }, 
           download: { id: '517392161752311980', name: "Download"  , message:"" }, 
             export: { id: '517392161752311981', name: "Export"    , message:"" }, 
                GET: { id: '517392161752311982', name: "HTTP GET"  , message:"" }, 
               POST: { id: '517392161752311983', name: "HTTP POST" , message:"" }, 
             DELETE: { id: '517392161752311984', name: "HTTP DELETE" , message:"" }, 
                PUT: { id: '517392161752311985', name: "HTTP PUT"  , message:"" }, 
             detail: { id: '517392161752311986', name: "Detail"    , message: "Record Access by Details" }, 
        };
    }
}

export default SettingsApplications;